import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUpload } from "@fortawesome/free-solid-svg-icons";

import greenCheck from "../../../assets/green-check.png";
import viewIcon from "../../../assets/view-icon.png";
import deleteIcon from "../../../assets/delete-icon.png";
import { handleEyeClick } from "../../../shared/utils/fileDownload";

const QualificationFamilyDetails = ({
    formData,
    setFormData,
    handleChange,
    errors,
    handleQualificationChange,
    handleCertificationChange,
    handleFamilyChange,
    handleGratuityChange,


}) => {

    return (
        <>

            {formData?.qualificationDetails?.map((qualification, index) => (
                <div
                    key={index}
                    className="px-4 pb-4 rounded row g-4 formfields bg-white border shadow-sm mb-5"
                >
                    <div className="section-header">
                        <span className="section-header-title">
                            Qualification Details - {qualification.courseName}
                        </span>
                    </div>

                    {/* Course Name */}
                    <div className="col-lg-3 col-md-6">
                        <label className="form-label">
                            Name of the Course
                            <span className="text-danger">*</span>
                        </label>

                        <select
                            disabled
                            className={`form-select onboarding-input ${errors?.[index]?.courseName ? "is-invalid" : ""
                                }`}
                            value={qualification.courseName || ""}
                        >
                            <option value={qualification.courseName}>
                                {qualification.courseName || "Select Course"}
                            </option>
                        </select>

                        {errors?.[index]?.courseName && (
                            <small className="text-danger">
                                {errors[index].courseName}
                            </small>
                        )}
                    </div>

                    {/* School */}
                    <div className="col-lg-3 col-md-6">
                        <label className="form-label">
                            Name of the School / Institution
                            <span className="text-danger">*</span>
                        </label>

                        <input
                            type="text"
                            disabled
                            className={`form-control onboarding-input ${errors?.[index]?.schoolInstitution
                                ? "is-invalid"
                                : ""
                                }`}
                            value={qualification.schoolInstitution || ""}
                        />

                        {errors?.[index]?.schoolInstitution && (
                            <small className="text-danger">
                                {errors[index].schoolInstitution}
                            </small>
                        )}
                    </div>

                    {/* Specialization */}
                    <div className="col-lg-3 col-md-6">
                        <label className="form-label">
                            Specialization
                            <span className="text-danger">*</span>
                        </label>

                        <select
                            disabled
                            className={`form-select onboarding-input ${errors?.[index]?.specializationName
                                ? "is-invalid"
                                : ""
                                }`}
                            value={qualification.specializationName || ""}
                        >
                            <option value={qualification.specializationName}>
                                {qualification.specializationName ||
                                    "Select Specialization"}
                            </option>
                        </select>

                        {errors?.[index]?.specializationName && (
                            <small className="text-danger">
                                {errors[index].specializationName}
                            </small>
                        )}
                    </div>

                    {/* University */}
                    <div className="col-lg-3 col-md-6">
                        <label className="form-label">
                            Name of University
                            <span className="text-danger">*</span>
                        </label>

                        <select
                            disabled
                            className={`form-select onboarding-input ${errors?.[index]?.universityName
                                ? "is-invalid"
                                : ""
                                }`}
                            value={qualification.universityName || ""}
                        >
                            <option value={qualification.universityName}>
                                {qualification.universityName ||
                                    "Select University"}
                            </option>
                        </select>

                        {errors?.[index]?.universityName && (
                            <small className="text-danger">
                                {errors[index].universityName}
                            </small>
                        )}
                    </div>

                    {/* Percentage */}
                    <div className="col-lg-3 col-md-6">
                        <label className="form-label">
                            Percentage of Marks (%)
                            <span className="text-danger">*</span>
                        </label>

                        <input
                            type="number"
                            disabled
                            className={`form-control onboarding-input ${errors?.[index]?.percentageMarks
                                ? "is-invalid"
                                : ""
                                }`}
                            value={qualification.percentageMarks || ""}
                        />

                        {errors?.[index]?.percentageMarks && (
                            <small className="text-danger">
                                {errors[index].percentageMarks}
                            </small>
                        )}
                    </div>

                    {/* Date of Passing */}
                    <div className="col-lg-3 col-md-6">
                        <label className="form-label">
                            Date of Passing
                            <span className="text-danger">*</span>
                        </label>

                        <input
                            type="date"
                            disabled
                            className={`form-control onboarding-input ${errors?.[index]?.dateOfPassing
                                ? "is-invalid"
                                : ""
                                }`}
                            value={qualification.dateOfPassing || ""}
                        />

                        {errors?.[index]?.dateOfPassing && (
                            <small className="text-danger">
                                {errors[index].dateOfPassing}
                            </small>
                        )}
                    </div>

                    {/* Division */}
                    <div className="col-lg-3 col-md-6">
                        <label className="form-label">
                            Division
                            <span className="text-danger">*</span>
                        </label>

                        <input
                            type="text"
                            placeholder="Enter division"
                            className={`form-control onboarding-input ${errors?.qualificationDetails?.[index]?.division
                                ? "is-invalid"
                                : ""
                                }`}
                            value={qualification.division || ""}
                            onChange={(e) =>
                                handleQualificationChange(
                                    index,
                                    "division",
                                    e.target.value
                                )
                            }
                        />


                        {errors?.qualificationDetails?.[index]?.division && (
                            <small className="text-danger">
                                {errors?.qualificationDetails?.[index]?.division}
                            </small>
                        )}
                    </div>

                    {/* Nature Of Course */}
                    <div className="col-lg-3 col-md-6">
                        <label className="form-label">
                           Education Type
                            <span className="text-danger">*</span>
                        </label>

                        <select
                            disabled
                            className={`form-select onboarding-input ${errors?.[index]?.natureOfCourse
                                ? "is-invalid"
                                : ""
                                }`}
                            value={qualification.natureOfCourse || ""}
                        >
                            <option value={qualification.natureOfCourse}>
                                {qualification.natureOfCourse ||
                                    "Select Nature Of Course"}
                            </option>
                        </select>

                        {errors?.[index]?.natureOfCourse && (
                            <small className="text-danger">
                                {errors[index].natureOfCourse}
                            </small>
                        )}
                    </div>
                </div>
            ))}





            {/* Certification Details */}
            {formData?.certificationDetails?.map(
                (certification, index) => (
                    <div
                        key={index}
                        className="px-4 pb-4 rounded row g-4 formfields bg-white border shadow-sm mb-5"
                    >
                        {/* <p
                    className="tab_headers"
                    style={{ marginBottom: "0px", marginTop: "1rem" }}
                >
                    Certification Details
                </p> */}

                        <div className="section-header">
                            <span className="section-header-title">
                                Certification Details
                            </span>
                        </div>

                        <div className="col-lg-3 col-md-6">
                            <label className="form-label">Name of the Certification<span className="text-danger">*</span></label>
                            <input
                                type="text"
                                disabled
                                placeholder="Enter name of the certification"
                                className={`form-select onboarding-input ${errors?.certificationName ? "is-invalid" : ""}`}
                                name="certificationName"
                                value={certification.certificationName || ""}
                                onChange={handleChange}
                            />

                            {errors.certificationName && (
                                <div className="invalid-feedback">
                                    {errors.certificationName}
                                </div>
                            )}
                        </div>

                        <div className="col-lg-3 col-md-6">
                            <label className="form-label">Name of the Institution<span className="text-danger">*</span></label>
                            <input
                                type="text"
                                disabled
                                placeholder="Enter name of the institution"
                                className={`form-select onboarding-input ${errors?.institutionName ? "is-invalid" : ""}`}
                                name="institutionName"
                                value={certification.institutionName || ""}
                                onChange={handleChange}
                            />

                            {errors.institutionName && (
                                <div className="invalid-feedback">
                                    {errors.institutionName}
                                </div>
                            )}
                        </div>

                        <div className="col-lg-3 col-md-6">
                            <label className="form-label">Date of Passing<span className="text-danger">*</span></label>
                            <input
                                type="date"
                                disabled
                                className={`form-control onboarding-input ${errors?.certificationDateOfPassing ? "is-invalid" : ""
                                    }`}
                                name="certificationDateOfPassing"
                                value={certification.certificationDateOfPassing || ""}
                                onChange={handleChange}
                            />



                            {errors?.certificationDateOfPassing && (
                                <div className="invalid-feedback">
                                    {errors.certificationDateOfPassing}
                                </div>
                            )}

                        </div>

                        <div className="col-lg-3 col-md-6">
                            <label className="form-label">Percentage of Marks (%)<span className="text-danger">*</span></label>
                            <input
                                type="number"
                                min="0"
                                max="100"
                                placeholder="Enter percentage of marks"
                                className={`form-control onboarding-input ${errors?.certificationDetails?.[index]
                                    ?.certificationPercentage
                                    ? "is-invalid"
                                    : ""
                                    }`}
                                value={
                                    certification.certificationPercentage || ""
                                }
                                onChange={(e) => {
                                    let value = e.target.value;

                                    if (Number(value) > 100) {
                                        value = 100;
                                    }

                                    handleCertificationChange(
                                        index,
                                        "certificationPercentage",
                                        value
                                    );
                                }}
                            />

                            {errors?.certificationDetails?.[index]?.certificationPercentage && (
                                <small className="text-danger">
                                    {errors?.certificationDetails?.[index]?.certificationPercentage}
                                </small>
                            )}
                        </div>

                        <div className="col-lg-3 col-md-6">
                            <label className="form-label">
                                Upload Your Documents <span className="text-danger">*</span>
                            </label>

                            {!certification.fileUrl ? (
                                <div
                                    className="border rounded d-flex flex-column align-items-center justify-content-center upload-box"
                                    style={{
                                        minHeight: "100px",
                                        cursor: "pointer"
                                    }}
                                    onClick={() =>
                                        document.getElementById("uploadDocumentInput").click()
                                    }
                                >
                                    <FontAwesomeIcon
                                        icon={faUpload}
                                        className="text-secondary"
                                    />

                                    <div
                                        className="mt-2"
                                        style={{
                                            color: "#7b7b7b",
                                            fontWeight: "500"
                                        }}
                                    >
                                        Click to upload
                                    </div>

                                    <div
                                        className="text-muted"
                                        style={{ fontSize: "12px" }}
                                    >
                                        PDF, JPG or PNG (Max 2MB)
                                    </div>

                                    <input
                                        id="uploadDocumentInput"
                                        type="file"
                                        accept=".jpg,.jpeg,.png,.pdf"
                                        style={{ display: "none" }}
                                        disabled
                                        onChange={(e) =>
                                            setFormData({
                                                ...formData,
                                                uploadDocument: e.target.files[0],
                                            })
                                        }
                                    />
                                </div>
                            ) : (
                                <div
                                    className="uploaded-file-box p-3 d-flex justify-content-between align-items-center"
                                    style={{
                                        border: "2px solid #bfc8e2",
                                        borderRadius: "8px",
                                        background: "#f7f9fc"
                                    }}
                                >
                                    <div className="d-flex align-items-center">
                                        <img
                                            src={greenCheck}
                                            alt="check"
                                            style={{
                                                width: "22px",
                                                height: "22px",
                                                marginRight: "10px"
                                            }}
                                        />

                                        <div>
                                            <div
                                                style={{
                                                    fontWeight: 600,
                                                    color: "#42579f"
                                                }}
                                            >
                                                {certification.displayName}
                                            </div>


                                        </div>
                                    </div>

                                    <div className="d-flex gap-2">
                                        <img
                                            src={viewIcon}
                                            alt="View"
                                            style={{
                                                width: "25px",
                                                cursor: "pointer"
                                            }}
                                            onClick={() =>
                                                handleEyeClick(
                                                    certification.fileUrl
                                                )
                                            }
                                        />

                                    </div>
                                </div>
                            )}

                            {errors?.uploadDocument && (
                                <small className="text-danger d-block mt-1">
                                    {errors.uploadDocument}
                                </small>
                            )}
                        </div>
                    </div>

                )
            )}

            {/* Family Details */}
            < div className="px-4 pb-4 rounded row g-4 formfields bg-white border shadow-sm mb-5" >
              

                < div className="section-header" >
                    <span className="section-header-title">
                        Family Details
                    </span>
                </div >

                <div className="col-lg-3 col-md-6">
                    <label className="form-label">Full Name<span className="text-danger">*</span></label>
                    <input
                        type="text"
                        placeholder="Enter Full Name"
                        className={`form-control onboarding-input ${errors?.fullName ? "is-invalid" : ""
                            }`}
                        name="fullName"
                        value={formData?.preOnboardingFamilyDetails?.fullName || ""}
                        onChange={handleFamilyChange}
                    />

                    {errors?.fullName && (
                        <div className="invalid-feedback d-block">
                            {errors.fullName}
                        </div>
                    )}

                </div>

                <div className="col-lg-3 col-md-6">
                    <label className="form-label">Relationship<span className="text-danger">*</span></label>
                    <input
                        type="text"
                        placeholder="Enter Relationship"
                        className={`form-control onboarding-input ${errors?.relationship ? "is-invalid" : ""
                            }`}
                        name="relationship"
                        value={
                            formData?.preOnboardingFamilyDetails
                                ?.relationship || ""
                        }
                        onChange={(e) => {
                            const value = e.target.value.replace(
                                /[^A-Za-z\s]/g,
                                ""
                            );

                            handleFamilyChange({
                                target: {
                                    name: "relationship",
                                    value,
                                },
                            });
                        }}
                    />
                    {errors?.relationship && (
                        <div className="invalid-feedback d-block">
                            {errors.relationship}
                        </div>
                    )}

                </div>

                <div className="col-lg-3 col-md-6">
                    <label className="form-label">Date of Birth<span className="text-danger">*</span></label>
                    <input
                        type="date"
                        placeholder="Select Date of Birth"
                        className={`form-control onboarding-input ${errors?.dateOfBirth ? "is-invalid" : ""
                            }`}
                        name="dateOfBirth"
                        value={
                            formData?.preOnboardingFamilyDetails?.dateOfBirth || ""
                        }
                        onChange={handleFamilyChange}
                        max={new Date().toISOString().split("T")[0]}
                    />
                    {errors?.dateOfBirth && (
                        <div className="invalid-feedback d-block">
                            {errors.dateOfBirth}
                        </div>
                    )}
                </div>

                <div className="col-lg-3 col-md-6">
                    <label className="form-label">Nationality<span className="text-danger">*</span></label>
                    <input
                        type="text"
                        placeholder="Enter Nationality"
                        className={`form-control onboarding-input ${errors?.nationality ? "is-invalid" : ""
                            }`}
                        name="nationality"
                        value={
                            formData?.preOnboardingFamilyDetails?.nationality || ""
                        }
                        onChange={(e) => {
                            const value = e.target.value.replace(
                                /[^A-Za-z\s]/g,
                                ""
                            );

                            handleFamilyChange({
                                target: {
                                    name: "nationality",
                                    value,
                                },
                            });
                        }}
                    />
                    {errors?.nationality && (
                        <div className="invalid-feedback d-block">
                            {errors.nationality}
                        </div>
                    )}
                </div>

                <div className="col-lg-3 col-md-6">
                    <label className="form-label">
                        Dependent <span className="text-danger">*</span>
                    </label>

                    <select
                        className={`form-select onboarding-input ${errors?.dependent ? "is-invalid" : ""
                            }`}
                        name="dependent"
                        value={
                            formData?.preOnboardingFamilyDetails?.dependent || ""
                        }
                        onChange={handleFamilyChange}
                    >
                        <option value="">Select</option>
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                    </select>

                    {errors?.dependent && (
                        <div className="invalid-feedback d-block">
                            {errors.dependent}
                        </div>
                    )}
                </div>

                <div className="col-lg-3 col-md-6">
                    <label className="form-label">
                        Person With Benchmark Disability
                        <span className="text-danger">*</span>
                    </label>

                    <select
                        className={`form-select onboarding-input ${errors?.benchmarkDisability
                            ? "is-invalid"
                            : ""
                            }`}
                        name="benchmarkDisability"
                        value={
                            formData?.preOnboardingFamilyDetails
                                ?.benchmarkDisability || ""
                        }
                        onChange={handleFamilyChange}
                    >
                        <option value="">Select</option>
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                    </select>

                    {errors?.benchmarkDisability && (
                        <div className="invalid-feedback d-block">
                            {errors.benchmarkDisability}
                        </div>
                    )}
                </div>

                <div className="col-lg-3 col-md-6">
                    <label className="form-label">Occupation<span className="text-danger">*</span></label>
                    <input
                        type="text"
                        placeholder="Enter Occupation"
                        className={`form-control onboarding-input ${errors?.occupation ? "is-invalid" : ""
                            }`}
                        name="occupation"
                        value={
                            formData?.preOnboardingFamilyDetails?.occupation || ""
                        }
                        onChange={(e) => {
                            const value = e.target.value.replace(
                                /[^A-Za-z\s.-]/g,
                                ""
                            );

                            handleFamilyChange({
                                target: {
                                    name: "occupation",
                                    value,
                                },
                            });
                        }}
                    />
                    {errors?.occupation && (
                        <div className="invalid-feedback d-block">
                            {errors.occupation}
                        </div>
                    )}
                </div>

                <div className="col-lg-3 col-md-6">
                    <label className="form-label">Annual Income<span className="text-danger">*</span></label>
                    <input
                        type="number"
                        min="0"
                        placeholder="Enter Annual Income"
                        className={`form-control onboarding-input ${errors?.annualIncome ? "is-invalid" : ""
                            }`}
                        name="annualIncome"
                        value={
                            formData?.preOnboardingFamilyDetails?.annualIncome || ""
                        }
                        onChange={(e) => {
                            const value = e.target.value;

                            if (
                                value === "" ||
                                Number(value) >= 0
                            ) {
                                handleFamilyChange(e);
                            }
                        }}
                    />
                    {errors?.annualIncome && (
                        <div className="invalid-feedback d-block">
                            {errors.annualIncome}
                        </div>
                    )}
                </div>

                <div className="col-lg-3 col-md-6">
                    <label className="form-label">Mobile Number<span className="text-danger">*</span></label>
                    <input
                        type="text"
                        placeholder="Enter Mobile Number"
                        maxLength={10}
                        className={`form-control onboarding-input ${errors?.mobileNumber ? "is-invalid" : ""
                            }`}
                        name="mobileNumber"
                        value={
                            formData?.preOnboardingFamilyDetails?.mobileNumber || ""
                        }
                        onChange={(e) => {
                            const value = e.target.value.replace(
                                /[^0-9]/g,
                                ""
                            );

                            handleFamilyChange({
                                target: {
                                    name: "mobileNumber",
                                    value,
                                },
                            });
                        }}
                    />
                    {errors?.mobileNumber && (
                        <div className="invalid-feedback">
                            {errors.mobileNumber}
                        </div>
                    )}
                </div>
            </div >

            {/* Gratuity Nomination Details */}
            < div className="px-4 pb-4 rounded row g-4 formfields bg-white border shadow-sm mb-5" >
                {/* <p
                    className="tab_headers"
                    style={{ marginBottom: "0px", marginTop: "1rem" }}
                >
                    Gratuity Nomination Details
                </p> */}

                < div className="section-header" >
                    <span className="section-header-title">
                        Gratuity Nomination Details
                    </span>
                </div >

                <div className="col-lg-3 col-md-6">
                    <label className="form-label">
                        Name of Nominee <span className="text-danger">*</span>
                    </label>
                    <input
                        type="text"
                        placeholder="Enter Nominee Name"
                        className={`form-control ${errors?.nomineeName ? "is-invalid" : ""
                            }`}
                        name="nomineeName"
                        value={
                            formData?.preOnboardingGratuityNomination?.nomineeName || ""
                        }
                        onChange={(e) => {
                            const value = e.target.value.replace(
                                /[^A-Za-z.\s]/g,
                                ""
                            );

                            handleGratuityChange({
                                target: {
                                    name: "nomineeName",
                                    value,
                                },
                            });
                        }}
                    />
                    {errors?.nomineeName && (
                        <div className="invalid-feedback d-block">
                            {errors.nomineeName}
                        </div>
                    )}
                </div>

                <div className="col-lg-3 col-md-6">
                    <label className="form-label">
                        Nominee Relationship <span className="text-danger">*</span>
                    </label>
                    <input
                        type="text"
                        placeholder="Enter Nominee Relationship"
                        className={`form-control ${errors?.nomineeRelationship
                            ? "is-invalid"
                            : ""
                            }`}
                        name="nomineeRelationship"
                        value={
                            formData?.preOnboardingGratuityNomination
                                ?.nomineeRelationship || ""
                        }
                        onChange={(e) => {
                            const value = e.target.value.replace(
                                /[^A-Za-z\s]/g,
                                ""
                            );

                            handleGratuityChange({
                                target: {
                                    name: "nomineeRelationship",
                                    value,
                                },
                            });
                        }}
                    />
                    {errors?.nomineeRelationship && (
                        <div className="invalid-feedback d-block">
                            {errors.nomineeRelationship}
                        </div>
                    )}
                </div>

                <div className="col-lg-3 col-md-6">
                    <label className="form-label">
                        Age of Nominee <span className="text-danger">*</span>
                    </label>
                    <input
                        type="number"
                        min="1"
                        max="120"
                        placeholder="Enter Age"
                        className={`form-control ${errors?.nomineeAge ? "is-invalid" : ""
                            }`}
                        name="nomineeAge"
                        value={
                            formData?.preOnboardingGratuityNomination?.nomineeAge || ""
                        }
                        onChange={(e) => {
                            let value = e.target.value;

                            if (value === "" || (
                                Number(value) >= 1 &&
                                Number(value) <= 120
                            )) {
                                handleGratuityChange(e);
                            }
                        }}
                    />
                    {errors?.nomineeAge && (
                        <div className="invalid-feedback d-block">
                            {errors.nomineeAge}
                        </div>
                    )}
                </div>

                <div className="col-lg-3 col-md-6">
                    <label className="form-label">
                        Address of Nominee <span className="text-danger">*</span>
                    </label>
                    <textarea
                        rows="1"
                        placeholder="Enter Nominee Address"
                        className={`form-control ${errors?.nomineeAddress ? "is-invalid" : ""
                            }`}
                        name="nomineeAddress"
                        value={formData?.preOnboardingGratuityNomination?.nomineeAddress || ""}
                        onChange={handleGratuityChange}
                    />
                    {errors?.nomineeAddress && (
                        <div className="invalid-feedback d-block">
                            {errors.nomineeAddress}
                        </div>
                    )}
                </div>

                <div className="col-lg-3 col-md-6">
                    <label className="form-label">
                        Amount of Share (%) <span className="text-danger">*</span>
                    </label>
                    <input
                        type="number"
                        min="1"
                        max="100"
                        placeholder="Enter Share Percentage"
                        className={`form-control ${errors?.amountOfShare ? "is-invalid" : ""
                            }`}
                        name="amountOfShare"
                        value={
                            formData?.preOnboardingGratuityNomination
                                ?.amountOfShare || ""
                        }
                        onChange={(e) => {
                            let value = e.target.value;

                            if (value === "") {
                                handleGratuityChange(e);
                                return;
                            }

                            if (
                                Number(value) >= 1 &&
                                Number(value) <= 100
                            ) {
                                handleGratuityChange(e);
                            }
                        }}
                    />
                    {errors?.amountOfShare && (
                        <div className="invalid-feedback d-block">
                            {errors.amountOfShare}
                        </div>
                    )}
                </div>
            </div >
        </>
    );
};

export default QualificationFamilyDetails;